import React, { useState } from 'react'
import { Typography, Button } from '../../components'
import { Formik } from 'formik'
import * as Yup from 'yup'
import Input from '../../components/Form/Input'
import { Form, FormBody } from '../../components/Form/styles'
// eslint-disable-next-line import/no-named-as-default
// import ReCAPTCHA from 'react-google-recaptcha'
import { DefaultRegularPages } from '../DefaultPages'

import { auth } from '../../services/ecbrApi/Auth'
import history from '../../store/history'

import bigCheckIcon from '../../assets/Icons/bigCheckIcon.svg'

import { Container, SubContainer, Title, Description } from './styles'
import ErrorMessage from '../../components/Form/ErrorMessage'

const initialValues = {
  email: ''
}

const formSchema = Yup.object().shape({
  email: Yup.string().email('Email inválido').required('Campo obrigatório')
})

const Signup = () => {
  const [submitted, setSubmitted] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const onSubmit = async (_values) => {
    setIsLoading(true)
    try {
      await auth.forgotPassword(_values.email)
      setSubmitted(true)
    } catch (err) {
      console.log(err)
      setError('Ocorreu um erro ao redefinir sua senha. Tente novamente.')
    }
    setIsLoading(false)
  }

  return (
    <DefaultRegularPages>
      <Container>
        <SubContainer>
          <Title>Recuperar a Senha</Title>
          <Description>
            {submitted
              ? 'O link de recuperação de senha foi enviado para o e-mail cadastrado '
              : 'Perdeu a senha de acesso? Não se preocupe! Informe o e-mail cadastrado. Enviaremos um link para recadastrar sua nova senha:'}
          </Description>
          {!submitted ? (
            <Formik
              initialValues={initialValues}
              validationSchema={formSchema}
              onSubmit={onSubmit}
            >
              {() => (
                <Form>
                  <FormBody>
                    <Input name="email" label="Email" showValidIcon />
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {/* <ReCAPTCHA
                        sitekey="sitekey"
                        onChange={() => console.log('accept')}
                      /> */}
                    </div>
                    {error && <ErrorMessage>{error}</ErrorMessage>}
                  </FormBody>
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <Button
                      text="RECUPERAR SENHA"
                      type="submit"
                      width="200px"
                      variant="primary"
                      disabled={isLoading}
                    />
                  </div>
                </Form>
              )}
            </Formik>
          ) : (
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img src={bigCheckIcon} alt="check" />
              <Typography
                type="text"
                align="center"
                color="#7D7987"
                spacing="32px 0"
              >
                Acesse o link enviado para realizar o acesso a plataforma
                novamente
              </Typography>
              <Button
                text="LOGIN"
                variant="primary"
                width="200px"
                onClick={() => history.push('/login')}
              />
            </div>
          )}
        </SubContainer>
      </Container>
    </DefaultRegularPages>
  )
}

export default Signup
